/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".flex-table[_ngcontent-%COMP%]{display:flex;flex-direction:column;border:1px solid #d3d3d3;border-collapse:collapse;width:100%}.flex-row[_ngcontent-%COMP%]{display:flex;border-bottom:1px solid #d3d3d3}.flex-row[_ngcontent-%COMP%]:last-child{border-bottom:none}.flex-col[_ngcontent-%COMP%]{padding:10px;border-right:1px solid #d3d3d3;box-sizing:border-box}.flex-col[_ngcontent-%COMP%]:last-child{border-right:none}.col1[_ngcontent-%COMP%]{width:150px;flex-shrink:0}.col2[_ngcontent-%COMP%]{flex-grow:1}"];
export { styles as styles };
